// This file provides standard SVG icons for social media (Instagram, Facebook, YouTube)
// Usage: import { InstagramIcon, FacebookIcon, YouTubeIcon } from './SocialIcons';
import React from 'react';

export const InstagramIcon = ({ size = 20, style = {} }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" style={style} xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="6" fill="url(#ig-gradient)"/>
    <defs>
      <linearGradient id="ig-gradient" x1="0" y1="0" x2="24" y2="24" gradientUnits="userSpaceOnUse">
        <stop stopColor="#f09433"/>
        <stop offset="0.25" stopColor="#e6683c"/>
        <stop offset="0.5" stopColor="#dc2743"/>
        <stop offset="0.75" stopColor="#cc2366"/>
        <stop offset="1" stopColor="#bc1888"/>
      </linearGradient>
    </defs>
    <circle cx="12" cy="12" r="5" stroke="#fff" strokeWidth="2"/>
    <circle cx="18" cy="6" r="1" fill="#fff"/>
  </svg>
);

export const FacebookIcon = ({ size = 20, style = {} }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" style={style} xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="6" fill="#1877f3"/>
    <path d="M16 8.5h-2c-.3 0-.5.2-.5.5v2h2.2c-.1.7-.2 1.3-.2 2h-2v6h-2v-6h-2v-2h2v-1.5C12 8.1 13.1 7 14.5 7H16v1.5z" fill="#fff"/>
  </svg>
);

export const YouTubeIcon = ({ size = 20, style = {} }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" style={style} xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="6" fill="#ff0000"/>
    <polygon points="10,8 16,12 10,16" fill="#fff"/>
  </svg>
);
